// This file is generated by i18next-parser-workspaces, do not modify manually.
// Run `$ npx i18next-parser-workspaces` to update this file

export const NAMESPACES = ['account', 'common', 'cookiebanner', 'country', 'demo', 'epg', 'error', 'menu', 'search', 'us_state', 'user', 'video'];
